import { motion } from "framer-motion";
import { MessageSquareText, ClipboardCheck, Sparkles } from "lucide-react";

const STEPS = [
  {
    icon: MessageSquareText,
    num: "01",
    title: "Tell us what you need",
    desc: "Send the quote form or a quick WhatsApp message — describe your place and pick your services.",
  },
  {
    icon: ClipboardCheck,
    num: "02",
    title: "Get a free quote",
    desc: "We reply fast with a fair, no-obligation quote. On-site visits in Shanzu when the job needs a closer look.",
  },
  {
    icon: Sparkles,
    num: "03",
    title: "We make it shine",
    desc: "Our crew arrives on time with our own equipment and supplies. You come back to a transformed space.",
  },
];

export default function HowItWorks() {
  return (
    <section id="how" className="bg-[#1C3B2B] py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="mb-16 max-w-2xl"
        >
          <p className="font-jbm text-xs font-semibold uppercase tracking-[0.3em] text-[#D4A359]">How it works</p>
          <h2 className="font-display mt-4 text-3xl font-bold tracking-tight text-[#FBF9F5] sm:text-4xl lg:text-5xl">
            Three steps to a spotless property
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-3 md:gap-8">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.num}
              data-testid={`how-step-${i + 1}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
              className="group relative rounded-3xl border border-[#FBF9F5]/10 bg-[#FBF9F5]/[0.04] p-8 backdrop-blur-sm transition-[background-color,transform] duration-500 hover:bg-[#FBF9F5]/[0.08] hover:-translate-y-2 sm:p-10"
            >
              <span className="font-display absolute right-7 top-6 text-5xl font-extrabold text-[#FBF9F5]/10 transition-colors duration-500 group-hover:text-[#D4A359]/30">
                {s.num}
              </span>
              <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-[#C85A32] text-white shadow-[0_14px_30px_-12px_rgba(200,90,50,0.7)]">
                <s.icon size={24} />
              </span>
              <h3 className="font-display mt-7 text-xl font-bold text-[#FBF9F5] sm:text-2xl">{s.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-[#E2EFEA]/75 sm:text-base">{s.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
